import { SELECT_OPTION_ITEM_DATA } from '../../common/select';
import { WAREHOUSE_ITEM_DATA_RAW_INTER, WAREHOUSE_LIST_RAW_INTER } from './constant';

export const convertNovapostWarehouses = (arr: WAREHOUSE_LIST_RAW_INTER): SELECT_OPTION_ITEM_DATA[] => {
  if (!Array.isArray(arr)) return [];

  return arr.map((item: WAREHOUSE_ITEM_DATA_RAW_INTER) => ({
    value: item.ref,
    label: `${item.description} (${item.cityDescription})`,
  }));
};
